import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
    {
        q: "Is this a consultancy or done-for-you?",
        a: "Done-for-you. We build both engines, run the campaigns, and hand you the dashboard. Your team is in the room for weekly reviews — but we're operating the stack.",
    },
    {
        q: "Why is the initial setup fee mandatory?",
        a: "Week 1 is discovery, ICP work, technical wiring (pixels, Clay, RB2B, Instantly, Origami), and domain warm-up. The $2,500 one-time fee covers infrastructure the retainer never should. Without this foundation, you burn ad spend and email domains.",
    },
    {
        q: "How fast do we see qualified meetings?",
        a: "Phase 1 (Weeks 1–4) is infrastructure — do not expect meetings. Phase 2 (Weeks 5–8) delivers first cohort. Phase 3 (Weeks 9–12) hits steady-state. Working standard: 30 qualified meetings/month by Day 90 on Growth or Scale.",
    },
    {
        q: "Do you work outside Payment Automation SaaS?",
        a: "The book — and the system — is designed for Payment Automation. The framework generalizes to any considered B2B SaaS with a 4–9 month cycle and a multi-person buying committee. Ask us on the call.",
    },
    {
        q: "Which tools do we own vs. you provide?",
        a: "You own everything. Accounts (Meta, Google, Clay, Instantly, RB2B, Origami) are set up in your workspace. No lock-in, no hostage. If you leave, the whole system stays yours.",
    },
    {
        q: "Can we switch tiers mid-engagement?",
        a: "Yes — up or down at any month boundary. Most teams start on Growth and upgrade to Scale after the compounding loop kicks in (usually Month 3).",
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="container-x py-24 md:py-40"
        >
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="max-w-2xl mb-14"
            >
                <span className="tag">Questions</span>
                <h2 className="font-display uppercase text-white text-5xl md:text-7xl mt-4 leading-[0.9]">
                    Fine
                    <span className="font-editorial italic font-normal normal-case text-[#e84125] tracking-normal">
                        {" "}
                        print{" "}
                    </span>
                    only.
                </h2>
            </motion.div>
            <div className="border-t border-white/10">
                {faqs.map((f, i) => {
                    const isOpen = open === i;
                    return (
                        <div
                            key={i}
                            className="border-b border-white/10"
                            data-testid={`faq-item-${i}`}
                        >
                            <button
                                onClick={() => setOpen(isOpen ? -1 : i)}
                                data-testid={`faq-toggle-${i}`}
                                aria-expanded={isOpen}
                                className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left group"
                            >
                                <span className="flex items-baseline gap-4 md:gap-8">
                                    <span className="font-mono text-[0.7rem] tracking-[0.22em] text-[#e84125] mt-2">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="font-display uppercase text-white text-xl md:text-3xl leading-tight group-hover:text-[#e84125] transition-colors">
                                        {f.q}
                                    </span>
                                </span>
                                <span
                                    className={`font-mono text-2xl md:text-3xl text-white/60 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                                    aria-hidden
                                >
                                    +
                                </span>
                            </button>
                            <AnimatePresence initial={false}>
                                {isOpen && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{
                                            height: "auto",
                                            opacity: 1,
                                        }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.35 }}
                                        className="overflow-hidden"
                                    >
                                        <p className="font-body text-white/65 text-base md:text-lg leading-relaxed pb-8 pl-8 md:pl-16 max-w-[68ch]">
                                            {f.a}
                                        </p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
